var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.5L13.1667 13.1667M15 8.75C15 9.98613 14.6334 11.1945 13.9467 12.2223C13.2599 13.2501 12.2838 14.0512 11.1418 14.5242C9.99974 14.9973 8.74307 15.1211 7.53069 14.8799C6.31831 14.6388 5.20466 14.0435 4.33059 13.1694C3.45651 12.2953 2.86125 11.1817 2.62009 9.96931C2.37894 8.75693 2.50271 7.50027 2.97576 6.35823C3.4488 5.21619 4.24988 4.24007 5.27769 3.55331C6.3055 2.86656 7.51387 2.5 8.75 2.5C10.4076 2.5 11.9973 3.15848 13.1694 4.33058C14.3415 5.50268 15 7.0924 15 8.75Z",
    stroke: "#8E8E8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchAlt);
export default __webpack_public_path__ + "static/media/searchAlt.b21119e15c064c4ce8737f4bc70ace75.svg";
export { ForwardRef as ReactComponent };